require('dotenv').config();

const API_HOST = process.env.REACT_APP_API_HOST || 'https://api-staging.influencer.in';

// BrandConnect / Influencer API Service — separate FastAPI backend
const BC_API_HOST = process.env.REACT_APP_BC_API_HOST || 'https://bc-api.influencer.in';

// Local-only AI service (see ai-service/README.md). Holds the Anthropic API key,
// which must never reach this bundle — CRA inlines every REACT_APP_* value into
// the published JavaScript.
const AI_SERVICE_HOST = process.env.REACT_APP_AI_SERVICE_HOST || 'http://localhost:5175';

// const API_HOST = "https://team.influencer.in";
// const API_HOST = "http://localhost:8001";
const FACEBOOK_APP_ID = '449781952733647';
// Instagram API with Instagram Login — the direct route, no Facebook Page.
// A different Meta app product from FACEBOOK_APP_ID above, with its own app
// id. Leave IG_LOGIN_APP_ID empty and the sign-in page falls back to the
// Facebook route, so a missing value degrades rather than breaks.
const IG_LOGIN_APP_ID = process.env.REACT_APP_IG_LOGIN_APP_ID || '';
const IG_LOGIN_REDIRECT_URI =
  process.env.REACT_APP_IG_LOGIN_REDIRECT_URI ||
  `${window.location.origin}/instagram/callback`;
const IG_LOGIN_SCOPES = ['instagram_business_basic', 'instagram_business_manage_insights'];

// Legacy Instagram Basic Display API. Meta shut this down in December 2024
// and it never carried insights. Kept only because config.js exports it.
const INSTAGRAM_APP_ID = '487541268980617';
const INSTAGRAM_HOST = 'https://api.instagram.com/oauth/authorize';

const devConfig = {
  API_HOST: API_HOST,
};

const WHATSAPP_NUMBERS = [
  '+919958559379', '+918754493825'
]

const WHATSAPP_SEND_ONLY_TO_TEAM = true
const USE_ES = (process.env.REACT_APP_USE_ES || 'false') === 'true';
const USE_PLANNER_ES = (process.env.REACT_APP_USE_PLANNER_ES || 'false') === 'true';

// YouTube Organic vs Paid rollout gate. The dashboard card is gated
// separately per brand via displayPanels ('youtube_ad_stats'); this flag
// covers the surfaces with no brand context (creator profile card,
// BrandConnect insights editing). Off until prod testing signs off.
const FEATURE_YT_ADSTATS = (process.env.REACT_APP_FEATURE_YT_ADSTATS || 'false') === 'true';

// The brief-driven discovery drawer. It talks to the AI service, which today
// runs only on a developer's own machine -- in a deployed build AI_SERVICE_HOST
// resolves to the viewer's localhost, so every call fails and the drawer tells
// a client to start a node process. Off until that service has a real home.
// Video QC tab: show clearly-labelled sample data when the QC backend routes
// are missing. On by default only in local development, never in production
// unless set explicitly, so real users never see made-up verdicts.
const FEATURE_VIDEO_QC_SAMPLE =
  (process.env.REACT_APP_FEATURE_VIDEO_QC_SAMPLE || (process.env.NODE_ENV === 'development' ? 'true' : 'false')) === 'true';

const FEATURE_BRIEF_ASSISTANT =
  (process.env.REACT_APP_FEATURE_BRIEF_ASSISTANT || 'false') === 'true';

export { IG_LOGIN_APP_ID, IG_LOGIN_REDIRECT_URI, IG_LOGIN_SCOPES, USE_ES, USE_PLANNER_ES, FEATURE_YT_ADSTATS, FEATURE_BRIEF_ASSISTANT, FEATURE_VIDEO_QC_SAMPLE, API_HOST, BC_API_HOST, AI_SERVICE_HOST, devConfig, FACEBOOK_APP_ID, INSTAGRAM_APP_ID, INSTAGRAM_HOST, WHATSAPP_NUMBERS, WHATSAPP_SEND_ONLY_TO_TEAM };


export const DASHBOARD_PATH = '/dashboard/default';
export const HORIZONTAL_MAX_ITEM = 7;

export const MenuOrientation = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
};

export const ThemeMode = {
    LIGHT: 'light',
    DARK: 'dark'
};

export const ThemeDirection = {
    LTR: 'ltr',
    RTL: 'rtl'
};

const config = {
    menuOrientation: MenuOrientation.VERTICAL,
    miniDrawer: false,
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    mode: ThemeMode.LIGHT,
    presetColor: 'theme7',
    i18n: 'en',
    themeDirection: ThemeDirection.LTR,
    container: false
};

export default config;
